<div class="tt-o-header" :class="{'tt-o-header--with-border': withBorder}">
  <div class="tt-o-header__heading" role="heading" v-html="heading"></div>
  <p v-if="description" class="tt-o-header__text" v-html="description"></p>
</div>



// WEBPACK FOOTER //
// ./src/objects/header/header.html